import { AuthModulesV1 } from "core/auth/version1/AuthModules";
import { AuthModulesV2 } from "core/auth/version2/AuthModules";
import { AuthVersionState } from "core/state/authVersionState";
import { ReactElement } from "react";

export interface AuthVersioningProps {
  auth: (sso?: boolean) => JSX.Element;
  Login: () => JSX.Element;
  Logout: ({ type }: { type?: "nav" | "account" }) => JSX.Element;
  protect: (el: ReactElement) => ReactElement;
  updateClient: () => void;
  handleSsoSetup: (provider?: string) => void;
}

export const useAuthVersioning = (): AuthVersioningProps => {
  const authVersion = AuthVersionState.get();

  switch (authVersion) {
    case "latest":
      return AuthModulesV2();
    case "old":
    default:
      return AuthModulesV1();
  }
};
